import { DamageTypeEnum } from '@insurance/api/requests'
import { damageTypeLabels } from '@insurance/components'
import { Badge, Flex, Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  damageType?: DamageTypeEnum
}

const statusColors: Record<DamageTypeEnum, TagProps['color']> = {
  [DamageTypeEnum._1]: 'blue',
  [DamageTypeEnum._2]: 'green',
  [DamageTypeEnum._3]: 'red'
}

export const ClaimsDamageTypeStatusTag = ({ damageType }: Props) => {
  const { t } = useTranslation()

  if (!damageType) return null

  const color = statusColors[damageType]

  return (
    <Tag color={color}>
      <Flex gap={4}>
        <Badge color={color} />
        {t(damageTypeLabels[damageType])}
      </Flex>
    </Tag>
  )
}
